import { ExerciseDTO } from '@/generated';
import { useExerciseFactsQuery, useGlossaryQuery } from '@/hooks/query-hooks';
import { pathMap } from '@/navigation/paths';
import { exerciseDetailsListStyle, exerciseDetailsListSubheaderStyle, exerciseDetailsPaperListElevation, exerciseDetailsPaperListStyle } from '@/styles';
import { Link as LinkIcon } from '@mui/icons-material';
import { Box, List, ListItem, ListItemButton, ListItemText, ListSubheader, Paper, Stack } from '@mui/material';

export const ExerciseFactsList = (props: { exercise: ExerciseDTO }) => {
  const { exercise } = props;
  const { exerciseFacts } = useExerciseFactsQuery();

  return (
    <Paper sx={{ ...exerciseDetailsPaperListStyle }} elevation={exerciseDetailsPaperListElevation}>
      <List sx={exerciseDetailsListStyle} component={'nav'}>
        <ListSubheader sx={exerciseDetailsListSubheaderStyle}>Exercise Facts:</ListSubheader>
        {exercise.exerciseFactIds?.map((fId) => {
          const fact = exerciseFacts?.find((f) => fId === f.id);
          return (
            <ListItem key={fId} sx={{ alignItems: 'flex-start' }}>
              <ListItemText sx={{ flexBasis: '50%', pr: 2 }} primary={`- ${fact?.description}`} />
              <Stack sx={{ flexBasis: '50%', minWidth: 0 }}>
                {fact?.glossaryIds?.map((gid) => <GlossaryLinkListButton key={gid} glossaryId={gid} />)}
              </Stack>
            </ListItem>
          );
        })}
        {!exercise.exerciseFactIds?.length && (
          <ListItem>
            <ListItemText>None</ListItemText>
          </ListItem>
        )}
      </List>
    </Paper>
  );
};

const GlossaryLinkListButton = (props: { glossaryId: string }) => {
  const { glossaryId } = props;
  const { glossaryTerms } = useGlossaryQuery();
  const glossaryTerm = glossaryTerms?.find((gt) => gt.id === glossaryId);

  return (
    <ListItemButton href={`${pathMap.Glossary}/${glossaryId}`} sx={{ gap: 1 }}>
      <LinkIcon fontSize="small" />
      <Box component="span">{glossaryTerm?.name}</Box>
    </ListItemButton>
  );
};
